<template>
  <div class="systemDoor">
    <div class="systemDoorBox">
      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="searchData">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="clearFilter()">重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter" type="flex" style="align-items: center">
        <el-col :span="2" style="text-align: end;">
          <span class="label">门店</span>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model="filterData.searchTerm"
            placeholder="检查ID或名称"
            style="width: auto"
          ></el-input>
        </el-col>
        <el-col :span="2" style="text-align: end;">
          <span class="label">区域</span>
        </el-col>
        <el-col :span="6">
          <el-select
            class="area"
            v-model="filterData.region"
            placeholder="请选择"
            @change=changeFilter
            multiple
          >
            <el-option
              v-for="item in areaList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="text-align: end;">
          <span class="label" >省份</span>
        </el-col>
        <el-col :span="6">
          <el-select
            class="area"
            v-model="filterData.province"
            placeholder="请选择"
            multiple
            @change=changeFilter
          >
            <el-option
              v-for="item in provinceList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter" type="flex" style="align-items: center">
        <el-col :span="2" style="text-align: end;">
          <span class="label">城市</span>
        </el-col>
        <el-col :span="6">
          <el-select
            class="area"
            v-model="filterData.city"
            placeholder="请选择"
            multiple
            @change=changeFilter
          >
            <el-option
              v-for="item in cityList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="text-align: end;">
          <span class="label">客户</span>
        </el-col>
        <el-col :span="6">
          <el-select
            class="area"
            v-model="filterData.reseller"
            placeholder="请选择"
            multiple
            @change=changeFilter
          >
            <el-option
              v-for="item in customerList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="text-align: end;">
          <span class="label">门店类型</span>
        </el-col>
        <el-col :span="6">
          <el-select
            class="area"
            v-model="filterData.concept"
            placeholder="请选择"
            multiple
            @change=changeFilter
          >
            <el-option
              v-for="item in rankList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="10" class="filter" type="flex" style="align-items: center">
        <el-col :span="2" style="text-align: end;">
          <span class="label">是否Master V</span>
        </el-col>
        <el-col :span="6">
          <el-select
            class="area"
            v-model="filterData.masterV"
            placeholder="请选择"
          >
            <el-option
              :key="isMasterV"
              label="是"
              :value="1">
            </el-option>
            <el-option
              :key="isnotMasterV"
              label="否"
              :value="0">
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->
      <el-divider></el-divider>

      <el-row>
        <el-col :span="18">数据列表</el-col>
        <el-col :span="6">
          <el-button style="color: #67C23A; margin-right: 20px" type="text" @click="downloadTemplate"><i
            class="el-icon-info"></i>模板下载</el-button>
          <input type="file" ref="importFile" @change="importExcel" />
          <el-button
            plain
            round
            icon="el-icon-upload2"
            size="small"
            style="color: #67C23A"
            @click="$refs.importFile.click()">
            导 入
          </el-button>
          <el-button
            plain
            round
            icon="el-icon-download"
            size="small"
            style="color: #67C23A"
            @click="exportDoor">
            导 出
          </el-button>
        </el-col>
<!--        <el-col :span="2">-->
<!--          <el-button-->
<!--            plain-->
<!--            round-->
<!--            icon="el-icon-download"-->
<!--            size="small"-->
<!--            style="color: #67C23A"-->
<!--            @click="exportExcel"-->
<!--          >-->
<!--            导 出-->
<!--          </el-button>-->
<!--        </el-col>-->
      </el-row>

      <el-table
        style="width: 100%; margin-top: 20px"
        fit
        stripe
        :data="tableData"
        v-loading="tableLoading"
        border
      >
        <el-table-column
          sortable
          prop="name"
          label="门店名称"
        ></el-table-column>
        <el-table-column
          sortable
          prop="doorNo"
          label="门店编号"
          width="120"
        ></el-table-column>
        <!-- <el-table-column
          sortable
          prop="posId"
          label="posId"
          width="100"
        ></el-table-column> -->
        <el-table-column
          prop="regionName"
          label="区域"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="cityName"
          label="城市"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="resellerName"
          label="客户"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="concept"
          label="门店类型"
          width="150"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="masterV"
          label="是否master V"
          width="120"
          :formatter="masterVFormatter"
        >
        </el-table-column> -->
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" style="color: #606266" icon="el-icon-view" size="mini" @click="seeDetail(scope.row.id)"
            >查看 / 编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";

export default {
  name: "SystemDoor",
  data() {
    return {
      filterData: {},
      initialFilterData: {
        region: [], //区域
        city: [], //城市
        reseller: [], //客户
        concept: [], //等级
        province: [], //省份
        searchTerm: "", //搜索项
        masterV: "", //是否MasterV
      },
      areaList: [],
      cityList: [],
      customerList: [],
      provinceList: [],
      rankList: [],
      tableData: [], // 列表
      total: 10, // 总数量
      tableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
      },
      tableLoading: false
    }
  },
  mounted() {
    this.getData();
    this.clearFilter();
    this.getOptions();
  },
  methods: {
    async getOptions() {
      let res = await axios.post(vmsReqUrl+"door/queryConditions", _.omit(this.filterData, ['searchTerm']));
      if (res.data.code === 200) {
        const dataList = res.data.data;
        this.areaList = dataList.region;
        this.cityList = dataList.city;
        this.rankList = dataList.concept;
        this.customerList = dataList.reseller;
        this.provinceList = dataList.province;
      }
    },
    clearFilter() {
      this.filterData = _.cloneDeep(this.initialFilterData);
      this.getOptions();
    },
    changeFilter() {
      this.getOptions();
    },
    searchData () {
      this.tableConfig.current = 1;
      this.getData();
    },
    async getData() {
      // 获取列表
      this.tableLoading = true;
      const params = _.assign({}, this.tableConfig, this.filterData);
      let res = await axios.post(vmsReqUrl+"/door/list", params);
      res = res.data;
      if (res.code === 200) {
        this.tableData = res.data.records || [];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    seeDetail(id) {
      this.$router.push({ path: '/vms/systemDoorDetail', query: { id } });
    },
    async importExcel({ target }) {
      let formData = new FormData();
      formData.append("file", target.files[0]);
      let res = await axios.post(vmsReqUrl+"door/batchImportDoor", formData);
      if(res.data.code === 200) this.$message.success("导入成功！");
      else this.$message.error("导入失败！");
    },
    async exportExcel() {
      const params = _.assign({}, this.tableConfig, this.filterData);
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: vmsReqUrl+"export/exportDoorReport",
        data: params
      });
      console.log(data, fileName);
    },
    async exportDoor() {
      const params = _.assign({}, this.tableConfig, this.filterData);
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: vmsReqUrl+"/door/export",
        data: params
      });
      console.log(data, fileName);
    },
    masterVFormatter(row) {
      switch (row.masterV) {
        case 0:
          return '否'
          break;
        case 1:
          return "是"
          break;
        default:
          return ""
          break;
      }
    },
    async downloadTemplate() {
      let response = await axios({
        method: "post",
        responseType: "blob",
        url: vmsReqUrl+"/door/importTemplate",
      });

      let fileName = decodeURI(
        response.headers["content-disposition"].split("''")[1]
      );
      let res = response.data;
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    },
  }
};
</script>
<style lang="sass" scoped>
.systemDoor
  min-width: 1050px
  input[type=file]
    display: none
  .systemDoorBox
    padding: 20px
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px
    .filter
      margin-top: 30px
    .label
      font-size: 14px
      color: #606266
    .table-container
      margin-top: 20px
    footer
      padding-top: 20px
      text-align: right
</style>



// WEBPACK FOOTER //
// src/vms/pages/views/systemDoor.vue